var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 15,
    viewBox: "0 0 83 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53834 1.48496C5.70914 1.07432 6.29086 1.07432 6.46166 1.48496L7.46974 3.90867C7.54174 4.08179 7.70455 4.20008 7.89144 4.21506L10.508 4.42483C10.9514 4.46037 11.1311 5.01363 10.7934 5.30296L8.79979 7.01067C8.65739 7.13264 8.59521 7.32403 8.63871 7.50641L9.24778 10.0598C9.35098 10.4924 8.88035 10.8343 8.5008 10.6025L6.26063 9.23419C6.10062 9.13646 5.89938 9.13646 5.73937 9.23419L3.4992 10.6025C3.11965 10.8343 2.64902 10.4924 2.75222 10.0598L3.36129 7.50641C3.40479 7.32403 3.3426 7.13264 3.20021 7.01067L1.20664 5.30296C0.86887 5.01363 1.04863 4.46037 1.49196 4.42483L4.10856 4.21506C4.29545 4.20008 4.45826 4.08179 4.53026 3.90867L5.53834 1.48496Z",
    fill: "#F2F5F7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53834 1.50999C7.70914 1.09934 8.29086 1.09934 8.46166 1.50999L9.99874 5.20558C10.0707 5.3787 10.2336 5.49699 10.4204 5.51197L14.4102 5.83182C14.8535 5.86736 15.0332 6.42062 14.6955 6.70995L11.6557 9.31381C11.5133 9.43578 11.4512 9.62717 11.4947 9.80955L12.4234 13.7028C12.5265 14.1354 12.0559 14.4774 11.6764 14.2455L8.26063 12.1592C8.10062 12.0615 7.89938 12.0615 7.73937 12.1592L4.32363 14.2455C3.94408 14.4774 3.47345 14.1354 3.57665 13.7028L4.50534 9.80955C4.54884 9.62717 4.48665 9.43578 4.34426 9.31381L1.30453 6.70995C0.966758 6.42062 1.14652 5.86736 1.58985 5.83182L5.57955 5.51197C5.76645 5.49699 5.92925 5.3787 6.00126 5.20558L7.53834 1.50999Z",
    fill: "#FDB022"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5383 1.48496C22.7091 1.07432 23.2909 1.07432 23.4617 1.48496L24.4697 3.90867C24.5417 4.08179 24.7045 4.20008 24.8914 4.21506L27.508 4.42483C27.9514 4.46037 28.1311 5.01363 27.7934 5.30296L25.7998 7.01067C25.6574 7.13264 25.5952 7.32403 25.6387 7.50641L26.2478 10.0598C26.351 10.4924 25.8803 10.8343 25.5008 10.6025L23.2606 9.23419C23.1006 9.13646 22.8994 9.13646 22.7394 9.23419L20.4992 10.6025C20.1196 10.8343 19.649 10.4924 19.7522 10.0598L20.3613 7.50641C20.4048 7.32403 20.3426 7.13264 20.2002 7.01067L18.2066 5.30296C17.8689 5.01363 18.0486 4.46037 18.492 4.42483L21.1086 4.21506C21.2955 4.20008 21.4583 4.08179 21.5303 3.90867L22.5383 1.48496Z",
    fill: "#F2F5F7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5383 1.50999C24.7091 1.09934 25.2909 1.09934 25.4617 1.50999L26.9987 5.20558C27.0707 5.3787 27.2336 5.49699 27.4204 5.51197L31.4102 5.83182C31.8535 5.86736 32.0332 6.42062 31.6955 6.70995L28.6557 9.31381C28.5133 9.43578 28.4512 9.62717 28.4947 9.80955L29.4234 13.7028C29.5265 14.1354 29.0559 14.4774 28.6764 14.2455L25.2606 12.1592C25.1006 12.0615 24.8994 12.0615 24.7394 12.1592L21.3236 14.2455C20.9441 14.4774 20.4735 14.1354 20.5766 13.7028L21.5053 9.80955C21.5488 9.62717 21.4867 9.43578 21.3443 9.31381L18.3045 6.70995C17.9668 6.42062 18.1465 5.86736 18.5898 5.83182L22.5796 5.51197C22.7664 5.49699 22.9293 5.3787 23.0013 5.20558L24.5383 1.50999Z",
    fill: "#FDB022"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5383 1.48496C39.7091 1.07432 40.2909 1.07432 40.4617 1.48496L41.4697 3.90867C41.5417 4.08179 41.7045 4.20008 41.8914 4.21506L44.508 4.42483C44.9514 4.46037 45.1311 5.01363 44.7934 5.30296L42.7998 7.01067C42.6574 7.13264 42.5952 7.32403 42.6387 7.50641L43.2478 10.0598C43.351 10.4924 42.8803 10.8343 42.5008 10.6025L40.2606 9.23419C40.1006 9.13646 39.8994 9.13646 39.7394 9.23419L37.4992 10.6025C37.1196 10.8343 36.649 10.4924 36.7522 10.0598L37.3613 7.50641C37.4048 7.32403 37.3426 7.13264 37.2002 7.01067L35.2066 5.30296C34.8689 5.01363 35.0486 4.46037 35.492 4.42483L38.1086 4.21506C38.2955 4.20008 38.4583 4.08179 38.5303 3.90867L39.5383 1.48496Z",
    fill: "#F2F5F7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5383 1.50999C41.7091 1.09934 42.2909 1.09934 42.4617 1.50999L43.9987 5.20558C44.0707 5.3787 44.2336 5.49699 44.4204 5.51197L48.4102 5.83182C48.8535 5.86736 49.0332 6.42062 48.6955 6.70995L45.6557 9.31381C45.5133 9.43578 45.4512 9.62717 45.4947 9.80955L46.4234 13.7028C46.5265 14.1354 46.0559 14.4774 45.6764 14.2455L42.2606 12.1592C42.1006 12.0615 41.8994 12.0615 41.7394 12.1592L38.3236 14.2455C37.9441 14.4774 37.4735 14.1354 37.5766 13.7028L38.5053 9.80955C38.5488 9.62717 38.4867 9.43578 38.3443 9.31381L35.3045 6.70995C34.9668 6.42062 35.1465 5.86736 35.5898 5.83182L39.5796 5.51197C39.7664 5.49699 39.9293 5.3787 40.0013 5.20558L41.5383 1.50999Z",
    fill: "#FDB022"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5383 1.48496C56.7091 1.07432 57.2909 1.07432 57.4617 1.48496L58.4697 3.90867C58.5417 4.08179 58.7045 4.20008 58.8914 4.21506L61.508 4.42483C61.9514 4.46037 62.1311 5.01363 61.7934 5.30296L59.7998 7.01067C59.6574 7.13264 59.5952 7.32403 59.6387 7.50641L60.2478 10.0598C60.351 10.4924 59.8803 10.8343 59.5008 10.6025L57.2606 9.23419C57.1006 9.13646 56.8994 9.13646 56.7394 9.23419L54.4992 10.6025C54.1196 10.8343 53.649 10.4924 53.7522 10.0598L54.3613 7.50641C54.4048 7.32403 54.3426 7.13264 54.2002 7.01067L52.2066 5.30296C51.8689 5.01363 52.0486 4.46037 52.492 4.42483L55.1086 4.21506C55.2955 4.20008 55.4583 4.08179 55.5303 3.90867L56.5383 1.48496Z",
    fill: "#F2F5F7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5383 1.50999C58.7091 1.09934 59.2909 1.09934 59.4617 1.50999L60.9987 5.20558C61.0707 5.3787 61.2336 5.49699 61.4204 5.51197L65.4102 5.83182C65.8535 5.86736 66.0332 6.42062 65.6955 6.70995L62.6557 9.31381C62.5133 9.43578 62.4512 9.62717 62.4947 9.80955L63.4234 13.7028C63.5265 14.1354 63.0559 14.4774 62.6764 14.2455L59.2606 12.1592C59.1006 12.0615 58.8994 12.0615 58.7394 12.1592L55.3236 14.2455C54.9441 14.4774 54.4735 14.1354 54.5766 13.7028L55.5053 9.80955C55.5488 9.62717 55.4867 9.43578 55.3443 9.31381L52.3045 6.70995C51.9668 6.42062 52.1465 5.86736 52.5898 5.83182L56.5796 5.51197C56.7664 5.49699 56.9293 5.3787 57.0013 5.20558L58.5383 1.50999Z",
    fill: "#FDB022"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5383 1.48496C73.7091 1.07432 74.2909 1.07432 74.4617 1.48496L75.4697 3.90867C75.5417 4.08179 75.7045 4.20008 75.8914 4.21506L78.508 4.42483C78.9514 4.46037 79.1311 5.01363 78.7934 5.30296L76.7998 7.01067C76.6574 7.13264 76.5952 7.32403 76.6387 7.50641L77.2478 10.0598C77.351 10.4924 76.8803 10.8343 76.5008 10.6025L74.2606 9.23419C74.1006 9.13646 73.8994 9.13646 73.7394 9.23419L71.4992 10.6025C71.1196 10.8343 70.649 10.4924 70.7522 10.0598L71.3613 7.50641C71.4048 7.32403 71.3426 7.13264 71.2002 7.01067L69.2066 5.30296C68.8689 5.01363 69.0486 4.46037 69.492 4.42483L72.1086 4.21506C72.2955 4.20008 72.4583 4.08179 72.5303 3.90867L73.5383 1.48496Z",
    fill: "#F2F5F7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_4531_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5383 1.60997C75.7091 1.19932 76.2909 1.19932 76.4617 1.60996L77.9987 5.30556C78.0707 5.47868 78.2336 5.59696 78.4204 5.61194L82.4102 5.9318C82.8535 5.96734 83.0332 6.52059 82.6955 6.80993L79.6557 9.41378C79.5133 9.53576 79.4512 9.72715 79.4947 9.90952L80.4234 13.8028C80.5265 14.2354 80.0559 14.5773 79.6764 14.3455L76.2606 12.2592C76.1006 12.1615 75.8994 12.1615 75.7394 12.2592L72.3236 14.3455C71.9441 14.5773 71.4735 14.2354 71.5766 13.8028L72.5053 9.90952C72.5488 9.72715 72.4867 9.53576 72.3443 9.41378L69.3045 6.80993C68.9668 6.52059 69.1465 5.96734 69.5898 5.9318L73.5796 5.61194C73.7664 5.59696 73.9293 5.47868 74.0013 5.30556L75.5383 1.60997Z",
    fill: "#FDB022"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(51)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(51)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_4531_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 20,
    fill: "white",
    transform: "translate(68)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.2aafad273c8903350e17eee585bcd50d.svg";
export { ForwardRef as ReactComponent };